import { safeFetch } from '@/utils/typings/app-fetch';

const get = async <T = any>(path: string, options?: RequestInit) => {
  return safeFetch<T>(path, options);
};

export const httpGateway = {
  get,
};
